import React from 'react';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import css from './UserCard.module.css';
import default_user from '../../assets/default_user.png';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import LocationBadge from '../LocationBadge/LocationBadge';
import { SlLocationPin } from 'react-icons/sl';

const UserCard = ({
  id,
  fullName,
  rating,
  bio,
  roles,
  linkWorkVideo,
  profileImage,
  intl,
  location,
}) => {
  const userId = id?.uuid || id;

  // Only first 2 roles
  const displayedRoles = roles.slice(0, 2);

  // Helper to get video embed URL
  const getVideoEmbed = url => {
    if (!url) return null;
    try {
      const urlObj = new URL(url);
      let videoId = null;

      if (urlObj.hostname.includes('youtube.com')) {
        videoId = urlObj.searchParams.get('v');
        return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}`;
      } else if (urlObj.hostname.includes('youtu.be')) {
        videoId = urlObj.pathname.slice(1);
        return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}`;
      } else if (urlObj.hostname.includes('vimeo.com')) {
        videoId = urlObj.pathname.split('/').pop();
        return `https://player.vimeo.com/video/${videoId}?autoplay=1&muted=1&loop=1`;
      }
    } catch (err) {
      console.error('Invalid video URL:', url);
    }
    return null;
  };

  const videoSrc = getVideoEmbed(linkWorkVideo);

  return (
    <div className={css.card}>
      <div className={css.imageWrapper}>
        {videoSrc ? (
          <iframe
            className={css.frame}
            src={videoSrc}
            title="Video player"
            frameBorder="0"
            allow="pause; fullscreen; picture-in-picture"
            allowFullScreen
          ></iframe>
        ) : null}
        <Link to={`/u/${userId}`} className={css.viewProfileBtn}>
          <FormattedMessage id="UserCard.viewProfileLink" />
        </Link>
      </div>

      <div className={css.cardBody}>
        <div className={css.userHeader}>
          <div className={css.profileInfo}>
            <img src={profileImage || default_user} alt={fullName} className={css.avatar} />
            <span className={css.name}>{fullName}</span>
          </div>
          {rating && (
            <div className={css.rating}>
              <Star size={14} fill="black" stroke="black" />
              <span>{rating}</span>
            </div>
          )}
        </div>
        <p className={css.description}>{bio}</p>
        <div className={css.roles}>
          {displayedRoles.map((role, i) => (
            <span key={i} className={css.role}>
              <FormattedMessage id={role} />

              {/* {intl.formatMessage({ id: role })} */}
            </span>
          ))}
        </div>
        <div>
          <span className={css.root}>
            <SlLocationPin />
            {location.place}
          </span>
          {/* <LocationBadge locationContext={location} isSmall /> */}
        </div>
      </div>
    </div>
  );
};

export default UserCard;

//add rating

//location
